<rt-integration-item
  [heading]="'Slack'"
  [isIntegrationLoaded]="isSlackIntegrationLoaded()"
  [hasIntegration]="hasSlackIntegrations()"
  (integrate)="
    integrate.emit(); analytics.track('[Settings] Integrations_SlackIntegrateButtonClick')
  "
  (remove)="disconnect.emit()"
>
  <rt-icon icon name="slack" size="large" />

  <div description>
    {{ 'app.settings.integrations.slack.description' | translate }}
  </div>

  <div dropdown-items>
    <rt-dropdown-item (click)="edit.emit()">
      {{ 'app.common.edit' | translate }}
    </rt-dropdown-item>
  </div>
</rt-integration-item>
